<template>
  <v-container :class="'main-container' + (showDesktopVersion ? '' : ' zero-padding')">
    <v-layout wrap>
      <page-header />
      <top-menu v-if="showDesktopVersion" />
      <left-menu v-if="!showDesktopVersion" />
      <right-menu v-if="!showDesktopVersion" />
      <template v-if="!showDesktopVersion">
        <v-container class="search-form-container">
          <search-form />
        </v-container>
        <v-layout style="background:white; width: 100%;"
          :class="showDesktopVersion ? 'mt-3' : ''"
        >
          <div :style="(showDesktopVersion
            ? 'width:calc(100% - 240px);'
            : 'width:calc(100% - 20px);') + 'margin: 10px;'">
            <my-loader v-if="progressSearching" :spacing="50" />
            <objects-list v-else />
          </div>
        </v-layout>
      </template>
      <v-flex v-else xs12>
        <v-layout class="content-area" wrap>
          <div class="left-col">
            <search-form />
            <facebook-frame />
            <main-share />
            <banners v-if="detailedSearch" />
            <contact-banner />
            <dynamic-auto-height-info-box v-if="!detailedSearch" />
          </div>
          <div
            id="content-area"
            class="right-col"
            :style="(showDesktopVersion
            ? 'width:calc(100% - 240px);'
            : '')"
          >
            <my-loader v-if="progressSearching" :spacing="50" />
            <objects-list
              v-else
            />
          </div>
        </v-layout>
      </v-flex>
      <page-footer />
    </v-layout>
  </v-container>
</template>

<script>
import sharedComputed from './sharedComputed'
import DynamicAutoHeightInfoBox from './../components/DynamicAutoHeightInfoBox'
import sharedMethods from './../methods/sharedMethods'
import MyLoader from './../components/_MyLoader'
import FacebookFrame from './../components/_FacebookFrame'
import Banners from './../components/_Banners'
import ContactBanner from './../components/_ContactBanner'
import MainShare from './../components/_MainShare'
import PageHeader from './../components/_PageHeader'
import PageFooter from './../components/_PageFooter'
import SearchForm from './../components/SearchForm'
import ObjectsList from './../components/ObjectsList'
import TopMenu from './../components/TopMenu'
import LeftMenu from './../components/LeftMenu'
import RightMenu from './../components/RightMenu'
import { createHelpers } from 'vuex-map-fields'
import state from './../state.js'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'Home',

  metaInfo () {
    return this.getMetaTags()
  },

  components: {
    PageHeader,
    PageFooter,
    SearchForm,
    TopMenu,
    ObjectsList,
    Banners,
    ContactBanner,
    LeftMenu,
    RightMenu,
    MainShare,
    FacebookFrame,
    MyLoader,
    DynamicAutoHeightInfoBox
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,
  },

  mounted () {
    this.isHydrated = true
  },

  created () {
    if (!this.lang) {
      const lang = this.getLangFromSiteName()
      this.$router.push({ path: '/' + lang })
      this.$i18n.locale = lang
    }
    this.searchObjects()
    this.metaTitle = this.metaSiteName
    this.metaUrl = this.defaultMetaUrl
    this.metaDescription = this.defaultMetaDescription
    this.metaImage = this.defaultMetaImage
    this.setContentAreaWidth()
  },

  methods: {
    ...sharedMethods,

    getLangFromSiteName () {
      return 'en'
    }
  }
}
</script>
